/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Arnav",
  logo_name: "Arnav!!",
  full_name: "Arnav Singha",
  subTitle:
    "Full Stack Developer, Front End Developer, Open Source Enthusiast, Life Long Learner.",
  resumeLink:
    "https://drive.google.com/file/d/1tMLitr12z15n-Xnw6OQTX1XW4SawSWZc/view?usp=drive_link",
  mail: "mailto:arnav.singha2002@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/ArnavSingha",
  linkedin: "https://www.linkedin.com/in/arnav-singha/",
  gmail: "arnav.singha2002@gmail.com",
  twitter: "https://twitter.com/007_arnav",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive User Interfaces and Backend for web applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Creating application backend in Node, Php and Rest-API",
        "⚡ Integration of third party services such as Firebase",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#0972c3",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos-nodejs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
          
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "vscode-icons:file-type-java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "jQuery",
          fontAwesomeClassname: "simple-icons:jquery",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Apache",
          fontAwesomeClassname: "simple-icons:apache",
          style: {
            color: "#CA1A22",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        // {
        //   skillName: "C++",
        //   fontAwesomeClassname: "simple-icons:cplusplus",
        //   style: {
        //     color: "#E94E32",
        //   },
        // },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Experience hosting and managing websites",
        "⚡ Experience with Continuous Integration",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#5b77ef",
          },
        },
      ],
    },

  ],
};

const degrees = {
  degrees: [
    {
      title: "Dr B C Roy Engineering College - Durgapur.",
      subtitle: "Bachelors in Computer Application",
      logo_path: "bcroy.png",
      alt_name: "SSEC",
      duration: "2020 - 2023",
      descriptions: [
        "⚡  I'm currently pursuing my Bachelors in Computer Application.",
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        // "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my BCA. ",
      ],
      website_link: "https://bcrec.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "HackHustle",
      subtitle: "Hackathon",
      logo_path: "HackHustle.png",
      certificate_link:
        "https://drive.google.com/file/d/1BPJN9MDWd7g6V03gHRYVloch3eBLcsJJ/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "#1E09A4",
    },
    {
      title: "Webel-Fujisoft-Vara",
      subtitle: "Internship",
      logo_path: "webel.png",
      certificate_link:
        "https://drive.google.com/file/d/1k_zFQhicabMARfkl_sc83S69x6tQz7Xe/view?usp=share_link",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Oasis Infobyte",
      subtitle: "Internship",
      logo_path: "oasis.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1nzPIHeFSDhoBR48j2_m5mZs1hrLVUhmC/view?usp=share_link",
      alt_name: "Reply",
      color_code: "#8608E2",
    },
    // {
    //   title: "Training",
    //   subtitle: "Git Learning",
    //   logo_path: "Progate.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/1sD6GS8f2Fh5MHMWlf5DhXoMhu4mykW-f/view",
    //   alt_name: "Reply",
    //   color_code: "#88e7ce",
    // },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work / Internship",
  description:
    "I've completed three internship. I've mostly done projects on my own and I am actively looking for Job. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Full-Stack Developer Intern",
          company: "Webel-Fujisoft-Vara",
          company_url: "https://webelfujisoftvara.com/",
          logo_path: "webel.png",
          duration: "May 2022 - Sep 2022",
          location: "On Site",
          description: "Collaborated with senior team on some big projects and improved mobile usability by over 45.7% ⚡ Improved sites performance over 75% by reducing page load time from 57 seconds to 10 seconds ⚡ Implemented some security such as SQL injection and XSS on the Projects ⚡ Supported senior developers to developing products and fixed almost 200 bugs in product site",
          color: "#0071C5",
        },
        {
          title: "Front-end Development",
          company: "Oasis Infobyte",
          company_url: "https://oasisinfobyte.com/",
          logo_path: "oasis.jpg",
          duration: "Mar 2023 - Apr 2023",
          location: "Remote",
          description: "Created Front end of some client's website. also degined simple web application for better user experience, designed DB Schemas as well.",
          color: "#ee3c26",
        },
        {
          title: "MERN-Stack Developer Intern",
          company: "Tea Tech Solution",
          company_url: "https://teatechsolution.com/",
          logo_path: "tts.png",
          duration: "Jun 2023 - Sep 2023",
          location: "On Site",
          description: "Deployed full-fledged Production level Application using MERN Stack and PHP/MySQL ⚡ Collaborated with team and Utilized CDNs to help reduce latency by 28% and to achieve real-time updates ⚡ Implemented use of trpc to enhance data safety between server and client,MySQL, MongoDB to ensure secure user profile storage",
          color: "#4285F4",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create ReactJS and PHP Fullstack Projects, I enjoy doing Front-End. Below are some of my best projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "arnav.png",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others.",
    link: "https://medium.com/@arnav.singha2002",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    // {
    //   id: "0",
    //   name: "Mind Space",
    //   url: "https://www.mindspace.cf/",
    //   description:
    //     "This is Blogging website where users can create blogs, follow and unfollow other users, get summarized blog reccomendation on their dashboard and have a personalised searching mechanism.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Flask",
    //       iconifyClass: "cib-flask",
    //     },
    //   ],
    // },
    // {
    //   id: "1",
    //   name: "Youtube Downloader",
    //   url: "https://github.com/vvHacker007/Youtube-Downloader/",
    //   description:
    //     "A desktop GUI which can be used to download youtube videos and playlist with desired quality and type on desktop.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "2",
    //   name: "Tune In",
    //   url: "https://github.com/vvHacker007/Tune-In",
    //   description:
    //     "Tune in is a collaborative music playing system where multiple guests can join a room and enjoy the song being played. Guests can pause and vote to skip the current song.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos-react",
    //     },
    //     {
    //       name: "Django",
    //       iconifyClass: "logos-django",
    //     },
    //   ],
    // },
    // {
    //   id: "3",
    //   name: "Event Scheduler",
    //   url: "https://github.com/vvHacker007/Event-Scheduler",
    //   description:
    //     "It is an all-purpose scheduler software. It is designed to monitor all the activities and give appropriate reminders for them.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Flask",
    //       iconifyClass: "cib-flask",
    //     },
    //   ],
    // },
    // {
    //   id: "4",
    //   name: "Movie Reccomendation System",
    //   url: "https://github.com/vvHacker007/Movie-Recommendation-Systems",
    //   description:
    //     "Made three python kernels explaining and implementing the three different types of movie recommender systems.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   id: "3",
    //   name: "Login Authenticator",
    //   url: "https://github.com/vvHacker007/Login-Authenticator",
    //   description: "Made a template for a Login Authenticator using Flask ",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Flask",
    //       iconifyClass: "cib-flask",
    //     },
    //   ],
    // },
    // {
    //   id: "4",
    //   name: "Calculator",
    //   url: "https://github.com/vvHacker007/Calculator",
    //   description:
    //     "Made a GUI based Calculator. Also made an executable file for the project which can be downloaded and used by anyone on their personal computer.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "5",
    //   name: "Notepad",
    //   url: "https://github.com/vvHacker007/Notepad",
    //   description:
    //     "Made a GUI based Notepad. Also made an executable file for the project which can be downloaded and used by anyone on their personal computer.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "6",
    //   name: "Tetris",
    //   url: "https://github.com/vvHacker007/Tetris",
    //   description: "Made a GUI based arcade game Tetris using pygame.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "7",
    //   name: "Steganography",
    //   url: "https://github.com/vvHacker007/Steganography",
    //   description:
    //     "A CLI tool to conceal messages within a file, text, image, or video.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "OpenCV",
    //       iconifyClass: "logos-opencv",
    //     },
    //   ],
    // },
    // {
    //   id: "8",
    //   name: "Mini Paint",
    //   url: "https://github.com/vvHacker007/Mini-Paint",
    //   description: "GUI based Mini Paint Application.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "9",
    //   name: "Speedtest",
    //   url: "https://github.com/vvHacker007/Speed-test",
    //   description:
    //     "An internet speed testing application which can notify about the download speed, upload speed, and also the reaction time of the connection.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "10",
    //   name: "Cat Classifier",
    //   url: "https://github.com/vvHacker007/Cat-Classifier",
    //   description:
    //     "Binary Cat Classifier made by hard coding Neural Networks in Python without using libraries such as Tensorflow or keras.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // {
    //   id: "11",
    //   name: "Snake",
    //   url: "https://github.com/vvHacker007/Snake",
    //   description:
    //     "A snake game which covers all the basic features like score, high score and an automated speed increase simultaneously when the snake eats the food.",
    //   languages: [
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //   ],
    // },
    // {
    //   id: "12",
    //   name: "Score Predictor",
    //   url: "https://score-predictor-app.herokuapp.com/",
    //   description:
    //     "Predicts students score based on the number of hours the student puts in it.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "vscode-icons:file-type-html",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "vscode-icons:file-type-css",
    //     },
    //     {
    //       name: "JavaScript",
    //       iconifyClass: "logos-javascript",
    //     },
    //     {
    //       name: "Python",
    //       iconifyClass: "logos-python",
    //     },
    //     {
    //       name: "Flask",
    //       iconifyClass: "cib-flask",
    //     },
    //     {
    //       name: "Jupyter Notebook",
    //       iconifyClass: "logos-jupyter",
    //     },
    //   ],
    // },
    // 

    {
      id: "3",
      name: "TypoBlitz",
      url: "https://github.com/ArnavSingha/TypoBlitz",
      description:
        "Devloped a high-performance and responsive elegant typing test tool",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "Material UI",
          iconifyClass: "simple-icons:mui",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "NPM",
          iconifyClass: "vscode-icons:file-type-npm",
        },
        {
          name: "Grunt",
          iconifyClass: "vscode-icons:file-type-grunt",
        },
        {
          name: "Jest",
          iconifyClass: "vscode-icons:file-type-jest",
        },
        {
          name: "Docker",
          iconifyClass: "vscode-icons:file-type-docker",
        },
        {
          name: "Git",
          iconifyClass: "vscode-icons:file-type-git",
        },
      ],
    },

    {
      id: "3",
      name: "EyeBro",
      url: "https://github.com/ArnavSingha/EyeBro",
      description:
        "Eyebro is a platform dedicated to providing a seamless shopping experience for eyewear products",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "vscode-icons:file-type-tailwind",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        
        {
          name: "NPM",
          iconifyClass: "vscode-icons:file-type-npm",
        },
        {
          name: "MongoDB",
          iconifyClass: "vscode-icons:file-type-mongo",
        },
        {
          name: "Grunt",
          iconifyClass: "vscode-icons:file-type-grunt",
        },
        {
          name: "Webpack",
          iconifyClass: "vscode-icons:file-type-webpack",
        },
        {
          name: "Jest",
          iconifyClass: "vscode-icons:file-type-jest",
        },
        {
          name: "Docker",
          iconifyClass: "vscode-icons:file-type-docker",
        },
        {
          name: "Git",
          iconifyClass: "vscode-icons:file-type-git",
        },
      ],
    },

    {
      id: "4",
      name: "oriJEEn V2.0",
      url: "https://github.com/ArnavSingha/oriJEEn",
      description:
        "A high scale production level Student-management system",
      languages: [
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "Scss",
          iconifyClass: "vscode-icons:file-type-scss",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "MySQL",
          iconifyClass: "vscode-icons:file-type-mysql",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
        {
          name: "PHPUnit",
          iconifyClass: "vscode-icons:file-type-phpunit",
        },
        {
          name: "Docker",
          iconifyClass: "vscode-icons:file-type-docker",
        },
        {
          name: "Git",
          iconifyClass: "vscode-icons:file-type-git",
        },
        {
          name: "Heroku",
          iconifyClass: "simple-icons:heroku",
        },
      ],
    },

    {
      id: "0",
      name: "Portfolio Website",
      url: "",
      description: "You are stalking it right now 😉",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Scss",
          iconifyClass: "vscode-icons:file-type-scss",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "GraphQL",
          iconifyClass: "vscode-icons:file-type-graphql",
        },
        {
          name: "BaseUI",
          iconifyClass: "logos-base",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
        {
          name: "Jest",
          iconifyClass: "vscode-icons:file-type-jest",
        },
        {
          name: "Docker",
          iconifyClass: "vscode-icons:file-type-docker",
        },
        {
          name: "Husky",
          iconifyClass: "vscode-icons:file-type-husky",
        },
        {
          name: "Netlify",
          iconifyClass: "vscode-icons:file-type-netlify",
        },
        {
          name: "Git",
          iconifyClass: "vscode-icons:file-type-git",
        },
      ],
    },

    {
      id: "2",
      name: "Pictogram     2022",
      url: "https://github.com/ArnavSingha/Insta_clone",
      description:
        "It's a clone of Instagram, have mostly all features",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Scss",
          iconifyClass: "vscode-icons:file-type-scss",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "MySQL",
          iconifyClass: "vscode-icons:file-type-mysql",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
        {
          name: "Apache",
          iconifyClass: "vscode-icons:file-type-apache",
        },
        {
          name: "Git",
          iconifyClass: "vscode-icons:file-type-git",
        },
      ],
    },

    {
      id: "3",
      name: "Car-Rental",
      url: "https://github.com/ArnavSingha/Car_rental",
      description:
        "A car rental website enabling users to search, reserve cars, and give feedback, with an admin page for managing listings, reservations, returns, and feedback",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Less",
          iconifyClass: "vscode-icons:file-type-less",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "PHP",
          iconifyClass: "logos-php",
        },
        {
          name: "MySQL",
          iconifyClass: "vscode-icons:file-type-mysql",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
        {
          name: "Apache",
          iconifyClass: "vscode-icons:file-type-apache",
        },
        {
          name: "Git",
          iconifyClass: "vscode-icons:file-type-git",
        },
      ],
    },
  ],
};


export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
